import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
let router = new Router({
  routes: [
    {
      path: '/login',
      component: resolve => require(['../components/pages/login.vue'], resolve)
    },
    {
      path: '/',
      redirect: '/index'//登录页
    },
    {
      path: '/',
      component: resolve => require(['../components/common/home.vue'], resolve),
      children: [
        {
          path: '/index',
          component: resolve => require(['../components/pages/index.vue'], resolve)
        },
        {
          path: '/mine',
          component: resolve => require(['../components/pages/Mine.vue'], resolve)
        },
      ]
    },
    {
      path: '/authorize',
      component: resolve => require(['../components/pages/Authorize.vue'], resolve)
    },
    {
      path: '/answer',
      component: resolve => require(['../components/pages/Answer.vue'], resolve)
    },
    {
      path: '/introduce',
      component: resolve => require(['../components/pages/introduce.vue'], resolve)
    },
    {
      path: '/endPage',
      component: resolve => require(['../components/pages/endPage.vue'], resolve)
    },

    {
      path: '/creditValue',
      component: resolve => require(['../components/pages/CreditValue.vue'], resolve)
    },
    {
      path: '/profile',
      component: resolve => require(['../components/pages/Profile.vue'], resolve)
    },
    {
      path: '/tips',
      component: resolve => require(['../components/pages/Tips.vue'], resolve)
    },
    {
      path: '/summary',
      component: resolve => require(['../components/pages/summary.vue'], resolve)
    },
    // abc对接
    {
      path: '/abc/answer',
      component: resolve => require(['../components/pages/abc/Answer.vue'], resolve)
    },
    {
      path: '/abc/introduce',
      component: resolve => require(['../components/pages/abc/introduce.vue'], resolve)
    },
    {
      path: '/abc/summary',
      component: resolve => require(['../components/pages/abc/summary.vue'], resolve)
    },
    // 易思行对接
    {
      path: '/ysx/answer',
      component: resolve => require(['../components/pages/abc/Answer.vue'], resolve)
    },
    {
      path: '/ysx/introduce',
      component: resolve => require(['../components/pages/abc/introduce.vue'], resolve)
    },
    {
      path: '/ysx/summary',
      component: resolve => require(['../components/pages/abc/summary.vue'], resolve)
    },
    // 卓思维对接
    {
      path: '/zsw/answer',
      component: resolve => require(['../components/pages/abc/Answer.vue'], resolve)
    },
    {
      path: '/zsw/introduce',
      component: resolve => require(['../components/pages/abc/introduce.vue'], resolve)
    },
    {
      path: '/zsw/summary',
      component: resolve => require(['../components/pages/abc/summary.vue'], resolve)
    },
    //川观新闻
    {
      path: '/cg/introduce',
      component: resolve => require(['../components/pages/abc/introduce.vue'], resolve)
    }, {
      path: '/cg/answer',
      component: resolve => require(['../components/pages/abc/Answer.vue'], resolve)
    }, {
      path: '/cg/summary',
      component: resolve => require(['../components/pages/abc/summary.vue'], resolve)
    },
    {
      path: '/introduceforweibo',
      component: resolve => require(['../components/pages/introduceforweibo.vue'], resolve)
    },
  ]
})
// router.beforeEach((to, from, next) => {
//   if (to.query.href == 1) {
//     next();
//   } else {
//     if (to.path === '/login') { // 如果是登录页面的话，直接next()
//       next();
//     } else { // 否则 跳转到登录页面
//       if (getCookie('token') || sessionStorage.getItem('cookie')) {
//         next();
//       } else {
//         next({
//           path: '/login'
//         });
//       }

//     }
//   }

// })

export function getCookie(name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg))
    return (arr[2]);
  else
    return null;
}

//删除cookie
export function delCookie(name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null)
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
};
export default router



// WEBPACK FOOTER //
// ./src/router/index.js